export default __webpack_public_path__ + "static/media/noconversation.db1042c9.png";